import { DialogContent, Stack } from "@mui/material";
import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { Button } from "../../../components/Button";

interface WeeklyHoursLimitExceededBottomSheetProps {
  modalState: UseModalState;
  onConfirm: () => void;
  onClose: () => void;
  weeklyHoursLimit: number;
}

export function WeeklyHoursLimitExceededBottomSheet(
  props: WeeklyHoursLimitExceededBottomSheetProps
) {
  const { modalState, onConfirm, onClose, weeklyHoursLimit } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth size="large" variant="contained" onClick={onConfirm}>
            View My Shifts
          </Button>
          <Button fullWidth size="large" variant="outlined" onClick={onClose}>
            Go Back
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={6} alignItems="center" sx={{ py: 4 }}>
          <Title semibold variant="h4" component="h4" textAlign="center">
            You have reached the weekly hours limit at this workplace
          </Title>
          <Text
            color={(theme) => theme.palette.text.secondary}
            sx={{ textAlign: "center" }}
            variant="body1"
          >
            This workplace does not allow professionals to book more than {weeklyHoursLimit} hours
            of work per week. You can cancel your other booked shifts at this workplace to accept
            this invite ({CLIPBOARD_SCORE} penalties may apply).
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
